import React from 'react';
import T from 'i18n';
import TableWrapper from './TableWrapper';

const PresentModePage = () => {
  return <TableWrapper category={T.translate('case.presentMode')} />;
};

export default PresentModePage;
